import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslateServiceService {

  constructor(public translate : TranslateService) { }

  getLanguage() {
    let getLang = (localStorage.getItem('appLanguage')) ? localStorage.getItem('appLanguage') : 'en';
    console.log('getlang', getLang);
    
    this.translate.use(getLang!);
  }

  useLanguage(language: string) {
    console.log("Language: ",language);
    localStorage.setItem('appLanguage',language);
    this.translate.use(language);
  }
}
